module.exports = __webpack_public_path__ + "c16d10e8a40987ce03b1636c33b160cf.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-20.png
// module id = 1669
// module chunks = 0